import { Support } from '../components';

export function SupportPage() {
  return <Support />;
}
